var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-5"},[_c('vs-tabs',{attrs:{"alignment":"fixed"}},[_c('vs-tab',{attrs:{"label":"Tareas"}},[_c('v-tareas')],1),_c('vs-tab',{attrs:{"label":"Alumnos"}},[_c('v-estudiantes')],1),_c('vs-tab',{attrs:{"label":"Calificaciones"}},[_c('div',[_vm._v("Calificaciones")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }